/**
 * Created by chenqifeng on 2016/9/1.
 */

import app from './js_interface_for_app';

export default app;